/**
 * The status DOT's tone — grey open · blue in progress · amber needs review / revisions · red blocked · green done.
 * One mapping for the drawer's status switch and the task row's dot (ART-343: a row shows its status in the same
 * colour as the switch's dot), so the two cannot disagree about what colour "needs review" is.
 */
export function statusDotTone(status: string | null | undefined): string {
  switch (status) {
    case "in_progress":
      return "progress";
    case "needs_review":
      return "review";
    case "revisions_requested":
      return "revisions";
    case "blocked":
      return "blocked";
    case "approved":
    case "done":
      return "done";
    default:
      return "open";
  }
}
